import { render, staticRenderFns } from "./EventBanners.vue?vue&type=template&id=b79c45e4&scoped=true"
import script from "./EventBanners.vue?vue&type=script&lang=js"
export * from "./EventBanners.vue?vue&type=script&lang=js"
import style0 from "./EventBanners.vue?vue&type=style&index=0&id=b79c45e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79c45e4",
  null
  
)

export default component.exports